import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ReactJson from "react-json-view";

function BuroModal({
  openModalBuro,
  setOpenModalBuro,
  setSearchBuro,
  searchBuro,
  buroData,
}) {
  const onCloseModal = () => {
    setOpenModalBuro(false);
  };

  const onChangeSearch = (e) => {
    setSearchBuro(e.target.value);
  }

  return (
    <Transition appear show={openModalBuro} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={onCloseModal}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-50"
            leave="ease-in duration-200"
            leaveFrom="opacity-50"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          {/* <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span> */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="border border-gray-200 z-50 inline-block w-full max-w-xl p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900 flex justify-between"
              >
                <div>ข้อมูลบูโร</div>
                <div>
                  <input
                    onChange={onChangeSearch}
                    placeholder="Search tag, key"
                    value={searchBuro}
                    className="px-3  py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                  />
                </div>
              </Dialog.Title>
              <ReactJson
                src={buroData}
                name={false}
                enableClipboard={false}
                displayObjectSize={false}
                displayDataTypes={false}
              />
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default BuroModal;
